
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zh/security",
      function () {
        return require("private-next-pages/zh/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zh/security"])
      });
    }
  